import { CaseState } from 'app/area/case/types-store';

export const referenceCodeDataTag = (state: CaseState, uiEngineProps: any) => {

    const descriptor = uiEngineProps && uiEngineProps.componentDescriptor;

    return {
      codeDataTag: descriptor && descriptor.properties && descriptor.properties.referenceCodeDataTag
    };
};
